<template>
  <div class="row text-nowrap m-2 m-sm-4 font-italic">
    <div class="col">
      <div class="row">
        <div class="col w-100">
          <h4 class="color-main font-weight-bold">Управлявайте образователната институция дигитално с АдминПлюс!</h4>
          <h4>ДЕТСКИ ГРАДИНИ &#8226; УЧИЛИЩА &#8226; ЦСОП &#8226; ЦПЛР</h4>
        </div>
      </div>
      <div class="row">
        <div class="col flex-grow-1 flex-sm-grow-0 site-title-div">
          <div class="no-active-campaign">
            
            <h2><span class="text-danger">МОДУЛИ</span></h2>
            <br />
            <div class="ml-2">
              <h5>Списък-образец</h5>
              <h5>Електронен дневник</h5>
              <h5>Ученически профил</h5>
              <h5>Седмично разписание</h5>
              <h5>Справки</h5>
              <h5>Документация</h5>
              <h5>Книги за дейността</h5>
              <h5>Оценяване на персонала</h5>
              <h5>Хранене</h5>
              <h5>Такси</h5>
              <h5>Съобщения</h5>
              <h5>Календар на събитията</h5>
              
              <br />
              <h4>
                <a class="text-danger" href="https://dogovori.adminplus.bg/Presentations" target="_blank">Заявете демонстрация</a>
              </h4>
            </div>
          </div>
        </div>
        <div class="col flex-grow-1 flex-sm-grow-0 align-self-start text-right text-sm-left">
            <div class="no-active-campaign">
              <h2><span class="text-danger">АБОНАМЕНТ 2025/2026:</span></h2>
              <br />
              <h5 class="text-dark ml-2">
                <a href="https://adminplus.bg/downloads/AdminPlus_UCHILISHTA_2025-2026.pdf" target="_blank">Каталог за УЧИЛИЩА</a>
              </h5>
              <h5 class="text-dark ml-2">
                <a href="https://adminplus.bg/downloads/AdminPlus_DG_2025-2026.pdf" target="_blank">Каталог за ДЕТСКИ ГРАДИНИ</a>
              </h5>
              <h5 class="text-dark ml-2">
                <a href="https://adminplus.bg/downloads/AdminPlus_TsPLR_TsSOP_2025-2026.pdf" target="_blank">Каталог за ЦПЛР и ЦСОП</a>
              </h5>
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <!-- <h2><span class="text-danger">НОВО от 15.09.2024 г.:</span></h2>
              <h5><span class="color-main">Дневници за входяща и изходяща кореспонденция</span></h5>
              <div>
                От 15.09.2024 г. към модул „Книги за дейността“ ще бъдат налични:
                <ul>
                  <li>
                    Дневник за входяща кореспонденция
                  </li>
                  <li>
                    Дневник за изходяща кореспонденция
                  </li>
                </ul>
              </div> -->
              <br />
              <br />
              <br />
              <br />
              <br />
              <h4 class="mt-1">
                <a class="text-danger" href="https://dogovori.adminplus.bg/User/Login" target="_blank">Направете абонамент</a>
              </h4>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "no-active-main-component"
}
</script>

<style scoped>

</style>
